<template>    
	<main class="main-wrapper flex-grow-1" v-if="!showChild">
			<div class="d-flex align-items-center ">
				<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
						{{$t('998')}}
				</div>
			</div>
			<div class="divider"></div>
			<result-tab @setViewTab="setViewTab"></result-tab>
			<div class="container container--narrow pdt-30">
				<div class="t-headline11 font-m t-line-h-33 mgb-16">{{paperName}}</div>
				<component 
					:is="tabType"
					:periodPolicy="periodPolicy"
					:summary="summary"
					:pointPolicy="pointPolicy"
					:badges="badges"
				></component>
			</div>
	</main>
	<div v-else>
		<router-view></router-view>
	</div>
</template>

<script>
/**
 * 단독 시험 나의 시험 결과 상세 메인 컴포넌트(independent my exam result view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'
import ResultTab from './view/ResultTab'
import ViewResultMy from './view/ResultMy'
import ViewInformation from './view/Information'
import ViewRewardMy from './view/RewardMy'
const showListRouterChild = ['IndependentExamResultResult', 'IndependentExamResultTake', 'IndependentExamResultFeedback', 'IndependentExamResultFeedbackIssue', 'IndependentExamResultFeedbackQuestion'];
export default {
	data() {
		return {
			tabType: 'ResultMy',
			examineeId: null,
			paperData: null,
			periodPolicy: null,
			summary: '',
			pointPolicy: null,
			badges: null,
			paperName : '',
			showChild : false
		}
	},

	components: {
		'result-tab': ResultTab,
		'Information': ViewInformation,
		'RewardMy': ViewRewardMy,
		'ResultMy' : ViewResultMy,
	},
	mixins: [examMixin],

	mounted() {
		//console.log(this.$route, '__result view route')
		if(showListRouterChild.includes(this.$route.name)){
			this.showChild = true;
		}
		let responseData = null
		this.examineeId = this.$route.params.examineeId
		let params = {
			examineeId: this.examineeId,
			application: true
		}

		// get examinee view information
		examApi.independentExamineeExamView(params).then((response) => {
			this.paperData = response.data.data
			this.paperName = this.paperData.name
			this.periodPolicy = this.paperData.period
			this.summary =  this.paperData.summary
			this.pointPolicy = this.paperData.point
		})

		// get exam badge list
		examApi.badges(params).then((response) => {
			this.badges = response.data.data
		})

	},

	methods: {
		setViewTab(tabType) {
			this.tabType = tabType
		},

	}
}
</script>
<style scoped>
.title-txt{color: #212121; padding: 1.15rem 0 0 1.15rem; font-weight: 600;}
html[dir="rtl"] .title-txt{padding: 1.15rem 1.15rem 0 0;}
</style>